<template>
  <v-card color="v-card--bordered radius-5 px-4 py-2 mb-2">
    <v-row
      v-for="step in yacht.delivery_plan.steps"
      :key="step.id"
      :class="{ 'grey--text': !step.started && !step.ended, 'primary--text': step.started && !step.ended }"
      class="list--bordered py-1"
      no-gutters
      align="center"
    >
      <v-col class="body-1">
        <div>{{ step.short_title }}</div>
        <div
          v-if="step.type === 'delivery' && yacht.destination_base"
          class="caption"
        >
          <v-icon small>
            location_on
          </v-icon>
          {{ yacht.destination_base.name }}, {{ yacht.country.name }}
        </div>
      </v-col>
      <v-col
        cols="auto"
        class="caption"
      >
        <v-icon
          v-if="step.ended"
          small
        >
          check
        </v-icon>
        <span>
          {{ step.done_at || step.estimated_at | moment('D MMM YYYY') }}
        </span>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
  export default {
    name: 'SmallDeliveryPlan',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    }
  }
</script>
